import React, { useMemo, useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import { ArticlesTab } from '../components/ArticlesTab';
import { IssuesTab } from '../components/IssuesTab';
import { UsersTab } from '../components/UsersTab';
import { NewsTab } from '../components/NewsTab';
import { ActivityLogTab } from '../components/ActivityLogTab';
import { useAuth } from '../context/AuthContext';
import { hasRole, UserRole } from '../types/user';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const AdminDashboard: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = hasRole(user, UserRole.ADMIN);
  const [tabValue, setTabValue] = useState(0);

  const tabs = useMemo(() => {
    const base = [
      { label: 'Статьи', component: <ArticlesTab /> },
      { label: 'Выпуски', component: <IssuesTab /> },
      { label: 'Новости', component: <NewsTab /> },
    ];

    if (isAdmin) {
      base.splice(2, 0, { label: 'Пользователи', component: <UsersTab /> });
      base.push({ label: 'Журнал', component: <ActivityLogTab /> });
    }

    return base;
  }, [isAdmin]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Если роль сменилась и индекс вкладки вне диапазона
  const safeTabValue = tabValue < tabs.length ? tabValue : 0;

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {isAdmin ? 'Панель администратора' : 'Панель редактора'}
      </Typography>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={safeTabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))}
        </Tabs>

        {tabs.map((tab, index) => (
          <TabPanel key={tab.label} value={safeTabValue} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Paper>
    </Container>
  );
};

export default AdminDashboard;
